import { HttpRequestData, httpUtil } from '@esg/framework';

import { GoogleRatingStatus } from '@esg/shared/enum';
import { getEnv } from '@esg/shared';
import { GetAllClientReviewResponseItem } from './getAllClientReview';

export interface UpdateClientReviewRequest extends HttpRequestData {
    readonly pathData: {
        readonly id?: string;
        readonly reviewToken?: string;
    };
    readonly body: {
        readonly id?: string;
        readonly rating: number;
        readonly feedback?: string;
        readonly customerId?: string;
        readonly googleRatingStatus?: GoogleRatingStatus;
        readonly saleId?: string;
        readonly branchId?: string;
    },
}

export const updateClientReview = httpUtil.createHttpRequestMeta<
    UpdateClientReviewRequest,
    GetAllClientReviewResponseItem
>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    path: '/api/v1/reviews/:reviewToken/:id',
    method: 'PATCH',
});
